import React from 'react';
import { CodeDragItemType } from 'app/area/codetable/list/constants';
import { CodeDrag } from 'app/area/codetable/list/list-items/drag-and-drop/code-drag';
import { CodeDrop } from 'app/area/codetable/list/list-items/drag-and-drop/code-drop';
import { CodeListBranch, CodeListItem } from 'app/area/codetable/list/types-store';

interface DragAndDropItemProps {
  codeListBranch: CodeListBranch[];
  codeItem: CodeListItem;
  children: React.ReactNode;
  updateCodeParent: (codetableId: number, codeId: number, description: string) => void;
}

export const DragAndDropItem =
  ({ codeListBranch, codeItem, children, updateCodeParent }: DragAndDropItemProps) =>
    <CodeDrop
      codeListBranch={codeListBranch}
      dropCodeId={codeItem?.id}
      type={CodeDragItemType.codeTile}
      updateCodeParent={updateCodeParent}>
      <CodeDrag
        item={codeItem}
        type={CodeDragItemType.codeTile}>
        {children}
      </CodeDrag>
    </CodeDrop>;
